import noCoursePermissionTranslation from './index.json';

export default noCoursePermissionTranslation;
